var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect0, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAssessmentLib(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 39,
    viewBox: "0 0 43 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4.62061,
    y: 7.90283,
    width: 4.60728,
    height: 1.97455,
    rx: 0.987274
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 10.0503,
    y: 7.90283,
    width: 12.67,
    height: 1.97455,
    rx: 0.987274
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 10.0503,
    y: 12.5101,
    width: 12.67,
    height: 1.97455,
    rx: 0.987274
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 10.0503,
    y: 17.1173,
    width: 12.67,
    height: 1.97455,
    rx: 0.987274
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 10.0503,
    y: 22.2183,
    width: 12.67,
    height: 1.97455,
    rx: 0.987274
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 10.2151,
    y: 26.3319,
    width: 12.67,
    height: 1.97455,
    rx: 0.987274
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 4.62061,
    y: 12.6746,
    width: 4.60728,
    height: 1.97455,
    rx: 0.987274
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 4.78491,
    y: 17.4464,
    width: 4.60728,
    height: 1.97455,
    rx: 0.987274
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 4.78491,
    y: 22.2183,
    width: 4.60728,
    height: 1.97455,
    rx: 0.987274
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    x: 4.78491,
    y: 26.9901,
    width: 4.60728,
    height: 1.97455,
    rx: 0.987274
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.342268 0.333611C0.76211 -0.0641324 1.49409 0.00452127 1.49409 0.00452127H26.8341C26.8341 0.00452127 27.1554 -0.0268233 27.41 0.169074C27.7411 0.423741 27.6568 1.07407 27.6568 1.07407V36.6982C27.6568 36.6982 27.7391 37.5209 27.4923 38.0146C26.8341 37.3564 25.7827 36.2046 25.7827 36.2046V1.97907H1.98772V36.2046H25.7827C25.7827 36.2046 26.8341 37.3564 27.4923 38.0146C26.8341 38.2614 25.7827 38.1791 25.7827 38.1791H0.918178C0.918178 38.1791 0.520524 38.2534 0.259995 38.0146C-0.0242191 37.754 0.013176 37.1918 0.013176 37.1918L0.0131761 1.56771C0.0131761 1.56771 -0.1009 0.753454 0.342268 0.333611Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.1758 2.63726L34.4031 0.498169L42.8772 36.04L34.979 38.1791L26.1758 2.63726L28.8085 4.11817L36.2953 35.8755L40.5735 34.5591L33.0044 2.80181L28.8085 4.11817L26.1758 2.63726Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssessmentLib);
export default __webpack_public_path__ + "static/media/assessment-lib.76851d97a1e124bb7ec90f43853d2c66.svg";
export { ForwardRef as ReactComponent };